import { Fragment, memo, useMemo } from 'react';
import { Grid, IconButton } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { PmiInputFile } from 'shell/components/shared/file-input';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  getStateDocumentWizard,
  idStateDocumentWizard,
} from 'civil-status/constants/id-state-document-wizard';
import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';
import { SignatoriesVM, SignatureActVM } from 'civil-status/view-models/step-form';

interface FormAutographsSignatureProps {
  values?: SignatureActVM;
  onYesPreview: () => void;
  handleAddFile: (file: File) => void;
  onTrashPress: () => void;
  setOpenModal: (value: boolean) => void;
  onVerifyDocument: () => void;
}

const FormAutographsSignatureComponent = ({
  values,
  onYesPreview,
  handleAddFile,
  onTrashPress,
  setOpenModal,
  onVerifyDocument,
}: FormAutographsSignatureProps): React.ReactElement => {
  const document: TypeFile | undefined = useMemo(() => {
    return values?.document;
  }, [values?.document]);

  const signatories: Array<SignatoriesVM> | undefined = useMemo(() => {
    return values?.signatories;
  }, [values?.signatories]);

  const disabledDocumentInputFile: boolean = useMemo(() => {
    if (document?.idAnscAllegato) {
      return true;
    }

    if (Boolean(signatories?.find((item) => !item.isAutografa && !item.isVerify))) {
      return true;
    }

    return false;
  }, [document, signatories]);

  return (
    <Fragment>
      <Grid item xs={12} md={3}>
        <PmiButton color="cdmBrandThird" variant="outlined" onClick={onYesPreview}>
          Anteprima per firme autografe
        </PmiButton>
      </Grid>
      <Grid item xs={12} md={2}>
        Documento con firme autografe&nbsp;
        <PmiInputFile
          file={document}
          onChange={(file) => handleAddFile(file)}
          color="cdmBrandThird"
          showFilename={false}
          multiple={false}
          disabled={disabledDocumentInputFile}
        />
      </Grid>
      <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center">
        <a download={document?.name} href={document?.raw}>
          {document?.name}
        </a>
      </Grid>
      <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center">
        {getStateDocumentWizard(document?.codStato)}
      </Grid>
      <Grid item xs={12} md={1} display="flex" alignItems="center" justifyContent="center">
        <IconButton
          color="error"
          aria-label="eliminare documento allegato"
          component="span"
          onClick={onTrashPress}
          disabled={Boolean(document?.idAnscAllegato) || !Boolean(document?.raw)}
        >
          <DeleteIcon />
        </IconButton>
      </Grid>
      <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center">
        {!Boolean(document?.idAnscAllegato) ? (
          <PmiButton
            color="cdmBrandThird"
            variant="outlined"
            onClick={() => setOpenModal(true)}
            disabled={!Boolean(document?.raw)}
          >
            Invia
          </PmiButton>
        ) : (
          <PmiButton
            color="cdmBrandThird"
            variant="outlined"
            onClick={onVerifyDocument}
            disabled={document?.codStato === idStateDocumentWizard.Inserito}
          >
            Verifica
          </PmiButton>
        )}
      </Grid>
    </Fragment>
  );
};

FormAutographsSignatureComponent.displayName = 'Form autographs signature component';

const FormAutographsSignature = memo(FormAutographsSignatureComponent);

export default FormAutographsSignature;
